import { App } from 'app/standalone/app.module.js';

new App();
